import React from "react"
import { Parallax } from "react-scroll-parallax"
import ShareContent from "../share-content/share-content"
import blogImage from "../../images/blog/blog.jpg"
import "./blog-list.css"
import Footer from "../footer/footer"
import GetInTouch from "../get-in-touch/get-in-touch"
import BlogMeta from "./blog-meta"
import BlogModule from "./blog-module"
import BlogCategories from "./blog-categories"
import GetInTouchCta from "../get-in-touch-cta/get-in-touch-cta"
import BlogFilter from "./blog-filter"
import BlogTags from "./blog-tags"
import BlogNavigation from "./blog-navigation"
import SecLines from "../sec-lines/sec-lines"
import SEO from "../seo"
import scrollTo from "gatsby-plugin-smoothscroll"

export const BlogList = props => {
  const { pageContext, data } = props
  const { tags, latest_posts, categories, related_category } = data
  const posts = pageContext.group || props.data.posts.edges
  const pageTitle =
    pageContext.tag || pageContext.category
      ? `to ${
          pageContext.tag
            ? `${pageContext.tag} - Tag`
            : "Jezek Jan" || pageContext.category
            ? `${pageContext.category} - Category`
            : "Jezek Jan"
        }`
      : "Jezek Jan"
  return (
    <>
      <SEO
        title="My personal Blog"
        description={`${pageTitle} - You may find some interesting stuff...`}
        url={props.location.href}
      />

      <div id="wrapper" className="single-page-wrap">
        <div className="content">
          <Parallax
            tagOuter="section"
            className="parallax-section dark-bg sec-half parallax-sec-half-right"
            y={[-100, 100]}
            styleInner={{
              right: "0",
              backgroundImage: `"url(${blogImage})"`,
            }}
          >
            <div className="overlay"></div>
            <img
              className="bg par-elem"
              alt="Background"
              src={blogImage}
              style={{ width: "50%", height: "160%", objectFit: "cover" }}
            />
            <div className="pattern-bg"></div>
            <div className="container">
              <div className="section-title">
                <h1>
                  Manche nennen es <br /> <span>Blog</span>
                  <br />
                  {pageTitle}
                </h1>
                <p>
                  Dies sind meine Gedanken. Wie immer: Jedes zurückliegende
                  Denken gehört zu einem Augenblick in der Vergangenheit. Das
                  ist das Wesen eines Gedankens und eine Eigenschaft der Zeit.
                  Wenn Sie also etwas "Veraltetes" finden, seien Sie sich bitte
                  bewusst, dass alles, was ich poste, zum Zeitpunkt des
                  Schreibens für mich wahr war.
                </p>
                <div className="horizonral-subtitle">
                  <span>Blog</span>
                </div>
              </div>
              <a
                onClick={() => {
                  scrollTo("#sec1")
                }}
                title="Scroll down"
                className="custom-scroll-link hero-start-link"
              >
                <span>Los geht's</span>
                <i className="fal fa-long-arrow-down"></i>
              </a>
            </div>
          </Parallax>

          <div className="single-page-decor"></div>

          <div className="single-page-fixed-row blog-single-page-fixed-row">
            <div className="scroll-down-wrap">
              <div className="mousey">
                <div className="scroller"></div>
              </div>
              <span>Runter scrollen</span>
            </div>
            <BlogFilter />
          </div>

          <section data-scrollax-parent="true" id="sec1">
            <div
              className="section-subtitle left-pos"
              data-scrollax="properties: { translateY: '-250px' }"
            >
              <span>//</span>Blog
            </div>
            <div className="container">
              <div className="fl-wrap post-container">
                <div className="row">
                  <div className="col-md-8">
                    {posts.map(({ node }, index) => {
                      return <BlogMeta key={index} {...node} />
                    })}
                  </div>

                  <div className="col-md-4">
                    <div className="blog-sidebar fl-wrap fixed-bar">
                      <BlogModule title="Latest Posts" posts={latest_posts} />
                      {related_category ? (
                        <BlogModule
                          title="Related Posts"
                          posts={related_category}
                        />
                      ) : null}
                      <BlogTags tags={tags.group} />
                      <BlogCategories categories={categories} />
                    </div>
                  </div>

                  <div className="limit-box fl-wrap"></div>
                </div>
                <BlogNavigation title="Navigation" {...props} />
              </div>
            </div>

            <SecLines />
          </section>

          <GetInTouch />
        </div>

        <div className="height-emulator fl-wrap"></div>
        <Footer />
        <GetInTouchCta />
      </div>

      <ShareContent />
    </>
  )
}
